import { window } from "browser-monads";
import PropTypes from "prop-types";
import React from "react";
import { Helmet } from "react-helmet-async";
import { useDetectLanguage } from "../hooks/useDetectLanguage";

const SEO = ({ description, lang, title, url, keywords, noIndex }) => {
  const languageCode = useDetectLanguage(window.location);
  const aeLanguage = languageCode.languageCode;
  const shouldNoIndex =
    noIndex || (noIndex != null && noIndex !== "") || aeLanguage === "ae";

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang,
        }}
        title={title}
        description={description}>
        {shouldNoIndex && <meta name="robots" content="noindex,nofollow" />}
        <meta name="description" content={description} />
        <meta property="keywords" content={keywords} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={url} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="og:image"
          content="https://cashfreelogo.cashfree.com/cf-og.png"
        />
        <link rel="canonical" href={url} />

        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "url": "https://www.cashfree.com",
      "name": "${title}",
      "description": "${description}",
      "logo": "https://cashfreelogo.cashfree.com/cf-og.png"
    }
    `}
        </script>
        <script type="application/ld+json">
          {`
      {
    "@context": "https://schema.org",
    "@type":"Organization",
    "name": "Cashfree Payments",
    "url": "https://www.cashfree.com/",
    "logo": "https://cashfreelogo.cashfree.com/cf-og.png",
    "address": {
    "@type": "PostalAddress",
    "streetAddress": "Vaishnavi Summit, No. 6/B, Summit, 80 Feet Rd, Koramangala 1A Block, Koramangala 3 Block, Koramangala",
    "addressLocality": "Bengaluru",
    "addressRegion": "Karnataka",
    "postalCode": "560034",
    "addressCountry": "India"
    },
    "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "contact",
    "telephone": "",
    "email": "care@cashfree.com"
    },
    "sameAs":["https://www.facebook.com/gocashfree/",
    "https://twitter.com/gocashfree",
    "https://www.linkedin.com/company/cashfree/",
    "https://www.youtube.com/channel/UCX06yVYIREbM4lMRwVi_6Aw",
    "https://www.instagram.com/cashfree.payments/"]
    }
      `}
        </script>
      </Helmet>
    </>
  );
};

SEO.defaultProps = {
  lang: "en",
  description: "",
  url: "https://www.cashfree.com/",
  keywords: [],
  noIndex: "",
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  title: PropTypes.string.isRequired,
  url: PropTypes.string,
  noIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  keywords: PropTypes.arrayOf(PropTypes.string),
};

export default SEO;
